import React from 'react'
import { Manager, Popper, Reference } from 'react-popper'
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded } from 'react-redux-firebase'
import { branch, compose, renderNothing, lifecycle } from 'recompose'
import {
  blockLayoutSelector,
  colWidthSelector
} from 'app/store/selectors/boardSelectors'
import {
  activeThreadSelector,
  blockThreadsSelector,
  boardThreadsSelector,
  newThreadSelector
} from 'app/store/selectors/discussSelectors'
import ThreadNumber from './ThreadNumber'
import { currentBlockIdSelector } from 'app/store/selectors/selectors'
import { userIdSelector } from 'app/store/selectors/baseSelectors'
import i18n from 'i18n'
import { showNotification } from 'app/store/actions/alerts'
import { discussBlockHighlight, sidebarWidth } from '../../style'
import { sidebarShowingSelector } from '../../store/selectors/sidebarSelectors'
import { activityShowingSelector } from '../../store/selectors/activitySelectors'

const DiscussContianer = compose(
  connect(state => ({ currentBlock: currentBlockIdSelector(state) })),
  branch(
    // if there is a currentBlock (single-block view) and this discuss overlay is not it, don't render
    ({ blockId, currentBlock }) => currentBlock && !blockId,
    renderNothing
  ),
  connect(
    (state, { currentBlock }) => {
      const props = {
        userId: userIdSelector(state),
        newThread: newThreadSelector(state),
        sidebarOrActivity:
          sidebarShowingSelector(state) || activityShowingSelector(state),
        currentBlock,
        threads: currentBlock
          ? blockThreadsSelector(state)
          : boardThreadsSelector(state)
      }
      const activeThread = activeThreadSelector(state)
      if (props.threads && activeThread !== null) {
        props.activeThread = props.threads.find(({ id }) => id === activeThread)
        if (!props.activeThread) props.threadGone = true // TODO delete activity when thread is gone so we don't end up here
        let block
        if (props.activeThread && props.activeThread.blockId && !currentBlock) {
          const blockLayouts = blockLayoutSelector(state)
          const colWidth = colWidthSelector(state)
          block =
            blockLayouts &&
            blockLayouts[props.activeThread.blockId].scale(colWidth).style
        }
        props.highlightBlock = block
        props.positionThread = threadPositioner({
          activeThread: props.activeThread,
          block,
          sidebarOrActivity: props.sidebarOrActivity
        })
      }
      return props
    },
    { showNotification }
  ),
  firebaseConnect(({ boardId, userId }) => [
    `/discuss/threads/${boardId}`,
    `/discuss/viewedThreads/${userId}/${boardId}`
  ]),
  branch(({ threads }) => !isLoaded(threads), renderNothing),
  lifecycle({
    componentDidUpdate(oldProps) {
      if (this.props.threadGone && !oldProps.threadGone)
        this.props.showNotification(i18n.t('discuss.thread.notFound'))
    }
  })
)

const threadPositioner = ({
  block,
  activeThread,
  sidebarOrActivity
}) => renderThread => {
  // active thread seems bigger due to outline
  const outline = activeThread.blockId ? discussBlockHighlight.outlineWidth : 0
  const left = sidebarOrActivity ? sidebarWidth : 0
  return (
    <Manager>
      <Reference>
        {({ ref }) =>
          block ? (
            // a 'fake' block for the thread to position itself beside
            <div
              style={{ ...block, position: 'absolute', pointerEvents: 'none' }}
              ref={ref}
            />
          ) : (
            <ThreadNumber thread={activeThread} innerRef={ref} />
          )
        }
      </Reference>
      <Popper
        placement="right-start"
        modifiers={{
          flip: { behavior: ['right', 'left', 'bottom-end'] },
          offset: { offset: '0, 10' },
          preventOverflow: {
            padding: {
              top: 40 + outline,
              bottom: 10 + outline,
              left: 10 + outline + left, // TODO use board
              right: 10 + outline
            },
            boundariesElement: 'viewport' // TODO use board
          }
        }}
      >
        {renderThread}
      </Popper>
    </Manager>
  )
}

export default DiscussContianer
